import { fetchConToken } from '../helpers/fetch';

const EspecialidadesService = {
    traer : () => {
        return fetchConToken(`Especialidades`)
    },
    traerParaContratos : () => {
        return fetchConToken(`Especialidades/Contratos`)
    }
}

export {EspecialidadesService as default}